<template>

  <section class="bg-indonesia relative">
    <section class="">
      <div class="py-8 px-4 mx-auto max-w-screen-xl lg:pt-16 pb-4 lg:px-6 text-center">
        <div class="max-w-screen-lg text-gray-500 sm:text-lg"><h2
            class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900" v-html="title">
        </h2>
          <p class="mb-4 font-medium sm-max:text-xl text-22 max-w-3xl m-auto font-medium leading-tight text-gray-900" v-html="description">



          </p></div>
      </div>
    </section>
  </section>


</template>

<script setup>



defineProps({
  title: {
    type: String,
    default: 'Get A Box Of Six Custom Curated Flavors Every Season:<br/> Spring, Summer, Fall, Holiday, and Winter!',
  },
  description: {
    type: String,
    default: 'Subscribe now and elevate your coffee ritual into a seasonal symphony. Special introductory discount for our early subscribers. Your year is about to get a whole lot more flavorful.',
  },

})

defineBuilderComponent({
    friendlyName: "BoxSixCustomCuratedFlavors",
    canHaveChildren: true,
    inputs: [
        {
            name: "title",
            type: "richText",
            defaultValue: "Get A Box Of Six Custom Curated Flavors Every Season:<br/> Spring, Summer, Fall, Holiday, and Winter!"
        },
        {
            name: "description",
            type: "richText",
            defaultValue: "Subscribe now and elevate your coffee ritual into a seasonal symphony. Special introductory discount for our early subscribers. Your year is about to get a whole lot more flavorful."
        }
    ]
});
</script>